import { render, staticRenderFns } from "./taskRelationDocu.vue?vue&type=template&id=87d4972a"
import script from "./taskRelationDocu.vue?vue&type=script&lang=js"
export * from "./taskRelationDocu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87d4972a')) {
      api.createRecord('87d4972a', component.options)
    } else {
      api.reload('87d4972a', component.options)
    }
    module.hot.accept("./taskRelationDocu.vue?vue&type=template&id=87d4972a", function () {
      api.rerender('87d4972a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/moc/taskRelationDocu.vue"
export default component.exports